import React from 'react';
import {NavLink} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Role} from '../../../incase-domain/user';
import Button from '../../../incase-domain/components/button/Button';

export type SidebarMenuItemText =
    | 'home'
    | 'editor'
    | 'rooms'
    | 'connections'
    | 'users'
    | 'generator'
    | 'dashboard'
    | 'settings'
    | 'messaging'
    | 'presentationThemes';

export interface SidebarMenuItem {
    icon: string;
    iconUnselected?: string;
    text: SidebarMenuItemText;
    url: string;
    roles?: Role[];
    footer?: boolean;
}

interface SidebarItemProps {
    item: SidebarMenuItem;
    collapsed: boolean;
}

function SidebarItem({item, collapsed}: SidebarItemProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <NavLink to={item.url} end={item.url === '/'}>
            {({isActive}) => (
                <Button
                    className={`c-sidebar__button ${isActive ? 'c-sidebar__button--active' : ''} ${
                        collapsed ? 'c-sidebar__button--collapsed' : ''
                    }`}
                    fullWidth
                    align="left"
                    size="xl"
                    leading={isActive ? item.icon : item.iconUnselected || item.icon}
                    variant="ghost"
                    color="basic"
                >
                    {collapsed ? '' : t(`sidebar.${item.text}`)}
                </Button>
            )}
        </NavLink>
    );
}

export default SidebarItem;
